import React from 'react';
import PropTypes from 'prop-types';
import { SFNavigationOptions } from '../utils/types';
import css from './UserInfoRow.css';
import Icon from '../SF/MaterialIcon';
import UtilitaryLinksList from './UtilitaryLinksList';

export default class UserInfoRow extends React.Component {

  constructor() {
    super();
    this.state = { showUtilitaryLinks: false };
  }

  get utilitaryLinks() {
    return this.state.showUtilitaryLinks
      ? <UtilitaryLinksList options={this.props.utilitaryOptions} currentSection={this.props.currentSection} />
      : null;
  }

  get icon() {
    return this.state.showUtilitaryLinks ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
  }

  render() {
    return (
      <div>
        <div
          className={css['container']}
          aria-expanded={this.state.showUtilitaryLinks}
          onClick={() => this.setState({showUtilitaryLinks: !this.state.showUtilitaryLinks})}
          aria-label={`${this.state.showUtilitaryLinks ? "Hide" : "Show"} user options`}
          tabIndex="0"
          role="button"
          id="userOptions">
          <div>{this.props.name}</div>
          <div><Icon icon={this.icon} /></div>
        </div>
        {this.utilitaryLinks}
      </div>
    );
  }
}

UserInfoRow.propTypes = {
  isMobile: PropTypes.bool,
  utilitaryOptions: SFNavigationOptions.isRequired,
  name: PropTypes.string.isRequired,
  currentSection: PropTypes.string
};
